import React from 'react';
import './discover.css'; // Import the CSS file

const Discover = () => {
  return (
    <div id="discover" className="discover-animation"></div>
  );
}

export default Discover;